import { fieldErrorsFromApiError, type FieldErrors } from '../FormShell';
import { isApiStatus, problemDetail } from '../../lib/workApi';

/**
 * Turns a failed save into dialog state: on a 400, errors keyed by a field the form shows go
 * to that field, anything else (unknown keys, or no `errors` map) goes to the form banner.
 * Any other status goes to the form banner as the ProblemDetails detail.
 */
export function saveErrorState(
  err: unknown,
  knownFields: readonly string[],
): { fieldErrors: FieldErrors; formError: string | null } {
  if (!isApiStatus(err, 400)) {
    return { fieldErrors: {}, formError: problemDetail(err, 'Save failed. Please try again.') };
  }
  const all = fieldErrorsFromApiError(err);
  const known = new Set(knownFields.map((f) => f.toLowerCase()));
  const fieldErrors: FieldErrors = {};
  const leftovers: string[] = [];
  for (const [key, messages] of Object.entries(all)) {
    if (known.has(key.toLowerCase())) fieldErrors[key] = messages;
    else leftovers.push(...messages);
  }
  const formError =
    leftovers.length > 0
      ? leftovers.join(' ')
      : Object.keys(fieldErrors).length === 0
        ? problemDetail(err, 'Please check the form and try again.')
        : null;
  return { fieldErrors, formError };
}
